// Valores por defecto de versionsSga.
export const defaultVersionsSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultAction = () => {
    return "";
};

// Valor por defecto de version.
export const defaultVersion = () => {
    return {
        id: null,
        date_of_publication: null,
        version: null,
        subs_not_dangers: [],
    };
};

// Valores por defecto de statesSga.
export const defaultStatesSga = () => {
    return [
        {
            id: 0,
            name: "Inactivo",
        },
        {
            id: 1,
            name: "Activo",
        },
    ];
};

// Valores por defecto de filterVersionsSga.
export const defaultFilterSgaVersions = () => {
    return {
        date_of_publication_from: null,
        date_of_publication_to: null,
        version: null,
        is_active: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de activeVersions.
export const defaultActiveVersions = () => {
    return [];
};

// Valores por defecto de sustancias no peligrosas.
export const defaultsubsNotDangers = () => {
    return [];
};

export default {
    versionsSga: defaultVersionsSga(),
    action: defaultAction(),
    version: defaultVersion(),
    statesSga: defaultStatesSga(),
    filterVersionsSga: defaultFilterSgaVersions(),
    activeVersions: defaultActiveVersions(),
    subsNotDangers: defaultsubsNotDangers(),
};
